import { Directive } from '@angular/core';

@Directive({
    selector: '[wlmGridButtonsSecondSlot]',
    standalone: false
})
export class GridButtonsSecondSlotDirective {}
